import { defineNuxtPlugin } from '#app';

const permissions = (permissions) => {
    if(!permissions || !permissions.length){
        return false;
    }
    return {
        updateUser: permissions.includes('update-user'),
        deleteUser: permissions.includes('delete-user'),
        createUser: permissions.includes('create-user'),
        viewUser: permissions.includes('view-user'),
        viewProject: permissions.includes('view-project'),
        createProject: permissions.includes('create-project'),
        updateProject: permissions.includes('update-project'),
        deleteProject: permissions.includes('delete-project'),
        restoreProject: permissions.includes('restore-project'),
        viewTask: permissions.includes('view-task'),
        createTask: permissions.includes('create-task'),
        updateTask: permissions.includes('update-task'),
        deleteTask: permissions.includes('delete-task'),
        updateIncentive: permissions.includes('update-incentive'),
        createAccount: permissions.includes('create-account'),
        updateAccount: permissions.includes('update-account'),
        deleteAccount: permissions.includes('delete-account'),
        globalUserManagement: permissions.includes('global-user-management'),
        checkBalance: permissions.includes('check-balance'),
        payIncentive: permissions.includes('pay-incentive'),
        sendParticipantEmail: permissions.includes('send-participant-email'),
        updateProfileGroups: permissions.includes('update-profile-groups'),
        manageUsers: permissions.includes('manage-users'),
    };
};

export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.provide('permissions', permissions);
});
